import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/gpa-calculator/pages/CalculatorPage";

export const Route = createFileRoute("/gpa-calculator")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/gpa-calculator",
      title: m.gpa_meta_title(),
      description: m.gpa_meta_description(),
      toolName: m.gpa_tool_name(),
      faqs: [
        { q: m.gpa_faq_q1(), a: m.gpa_faq_a1() },
        { q: m.gpa_faq_q2(), a: m.gpa_faq_a2() },
        { q: m.gpa_faq_q3(), a: m.gpa_faq_a3() },
        { q: m.gpa_faq_q4(), a: m.gpa_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
